module.exports = __webpack_public_path__ + "d8c8c691ed6aa2ce08e13eab9510e6e5.png";